import { AxiosInstance } from 'axios';
import { ISelection } from '../../types/selector/Selector';

interface EvolvedMappingRequest {
  businessProductId: string;
  businessProductVersion?: string;
  businessProductOptions?: ISelection;
  context: Record<string, string>;
  mappingType?: string;
  mappingStatus?: string;
}

interface ProductMapping {
  mappingId: string;
  merchantProductId: string;
  merchantProductVersion: number;
  merchantProductConfiguration: ISelection;
  validationFailures: Array<{
    validationName?: string;
    failureReasons?: Array<string>;
  }>;
}

interface EvolvedMappingResponse {
  productMapping: Array<ProductMapping>;
}

class LegacyProductMappingService {
  httpClient: AxiosInstance;

  constructor(httpClient: AxiosInstance) {
    this.httpClient = httpClient;
  }

  async getEvolvedMapping(request: EvolvedMappingRequest): Promise<EvolvedMappingResponse> {
    const { data: { productMapping: [productMapping] } } = await this.httpClient.post<EvolvedMappingResponse>('v0/mappedMerchantProducts:evolve', request);
    if (!productMapping) {
      return Promise.reject(new Error('No product mapping found'));
    }
    return Promise.resolve({ productMapping: [productMapping] });
  }
}
export default LegacyProductMappingService;
